import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ConstsHelper } from '../../../../helpers/consts.helper';
import { AccountBillingAddressInterface } from '../../models/account-billing-address.interface';
import { AccountShippingAddressInterface } from '../../models/account-shipping-address.interface';
import { AccountInformationInterface } from '../../models/account-information.interface';

@Component({
  selector: 'app-account-billing-address',
  templateUrl: './account-billing-address.component.html',
  styleUrls: ['./account-billing-address.component.css'],
  standalone: false
})
export class AccountBillingAddressComponent implements OnInit {

  @Output()
  accountAddress = new EventEmitter<any>();

  @Input()
  accountInformation: AccountInformationInterface;

  form: FormGroup;
  formSubmitted: boolean;
  sameAddress: boolean;
  errors: any = {
    address: {
      required: `L'adresse est obligatoire.`,
      pattern: `Veuillez saisir une adresse avec au moins deux caractères et sans utiliser de caractères spéciaux ni accent.`
    },
    zipCode: {
      required: `Le code postal est obligatoire.`,
      pattern: `Le code postal saisie n'est pas valide.`
    },
    city: {
      required: `La ville est obligatoire.`,
      pattern: `Veuillez saisir un nom de ville sans accent, caractères spéciaux ni chiffres.`
    },
    addressComplement: {
      pattern:
          `Veuillez saisir un complément d\'adresse avec au moins deux caractères et sans utiliser de caractères spéciaux ni accent.`
    },
  };
  step: number;
  billingAddress: AccountBillingAddressInterface;
  shippingAddress: AccountShippingAddressInterface;

  constructor(private formBuilder: FormBuilder) {}

  ngOnInit() {
    this.formSubmitted = false;
    this.sameAddress = false;
    this.step = 1;
    this.initForm();
  }

  initForm() {
    this.form = this.formBuilder.group({});
    this.form = new FormGroup({
      address: new FormControl('', [Validators.required, Validators.pattern(ConstsHelper.addressPattern)]),
      zipCode: new FormControl('', [Validators.required, Validators.pattern(ConstsHelper.zipCodePattern)]),
      city: new FormControl('', [Validators.required, Validators.pattern(ConstsHelper.cityPattern)]),
      addressComplement: new FormControl('', [Validators.pattern(ConstsHelper.addressPattern)]),
    });
  }

  submit() {
    this.formSubmitted = true;
    if (this.form.valid) {
      this.billingAddress = {
        address: this.form.get('address').value,
        zipCode: this.form.get('zipCode').value,
        city: this.form.get('city').value,
        addressComplement: this.form.get('addressComplement').value,
      };
      if (!this.sameAddress) {
        this.step = 2;
      } else {
        this.shippingAddress = {
          shippingAddressCivility: this.accountInformation.civility,
          shippingAddressLastName: this.accountInformation.lastName,
          shippingAddressFirstName: this.accountInformation.firstName,
          address: this.form.get('address').value,
          zipCode: this.form.get('zipCode').value,
          city: this.form.get('city').value,
          addressComplement: this.form.get('addressComplement').value,
        };
        this.setAccountShippingAddress(this.shippingAddress);
      }
    }
  }

  setAccountShippingAddress(shippingAddress: any) {
    const data = {billingAddress: this.billingAddress, shippingAddress };
    this.accountAddress.emit(data);
  }

  getError(formControlName: string): string {
    let errorMsg = '';
    if (this.form.controls[formControlName].invalid) {
      Object.keys(this.form.controls[formControlName].errors).map(
          key => {
            errorMsg = this.errors[formControlName][key];
          }
      );
    }
    return errorMsg;
  }

  setSameAddress($event: any) {
    this.sameAddress = $event.target.checked;
  }
}
